export default __webpack_public_path__ + "static/media/Back_Pain.894c4657.png";